export const ArabicStrings = {
    language: "اللغة",
    settings: "إعدادات",
    theme: 'لون القشرة',
    light: 'ساطع',
    dark: 'مظلم',
    places: "أماکن",
    updating: "جارٍ التحدیث...",
    addingPlace: 'أضف الموقع',
    manual: 'إضافة یدویة',
    receive: 'احصل علی الموقع',
    roomName: 'اسم المکان',
    add: 'إضافه',
    cancel: 'الغإ',
    fetchingReceiveCode: 'جار الاستلام الرمز',
    enterThisCodeToGetPlaces: 'أدخل هذا الرمز للحصول علی الموقع.',
    anErrorOccurredPleaseCheckInternetConnection: "حدث خطأ، تأکد من أنک متصل بلإنترنت.",
    error: 'خطأ',
    ok: 'تأئید',
    pleaseEnterRoomName: 'الرجإ أدخل اسم المکان',
    pleaseEnterTargetUserCode: "الرجإ أدخل رمز المستخدم بالکامل",
    selectedRoomsSentSuccessfully: "تم إرسال المواقع المختارة بنجاح",
    userWithProvidedCodeDidNotFound:  "لم یتم العثور علی مستخدم بهذا الرمز",
    receivePlace: 'احصل علی الموقع',
    logOut: 'خروج',
    update: 'تحدیث',
    anErrorOccurredWhileConnectingToDevicePleaseTryAgain: 'حدث خطا في الإتصال بالجهاز، یرجی المحاولة مرة أخری',
    pleaseEnterRequestedInformations: ' الرجاء إدخال المعلومات المطلوبة',
    dataSusseccfullySentToDevicePleaseCloseAppAndConnectToInternet: 'تم إرسال المعلومات إلى الجهاز بنجاح.  أغلق البرنامج واتصل بالإنترنت.  يعد اختفاء شبكة zitco_config  علامة على التسجيل الكامل للجهاز.',
    anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork: 'حدث خطأ ، تأكد من أن الجهاز متصل بالشبكة.',
    errorInSocketConnection: 'خطأ في اتصال المقبس',
    deviceConfigurationIsNotPossibleWithWebApplication: 'لا يمكن تسجيل الجهاز بإصدار الويب',
    pleaseTurnOnLocationService: "يرجى التحقق أن موقعک مفعل",
    permissionDenied: "عدم الاتصال",
    plug: 'مَنفَذ کهربائی',
    AC: 'مکیف',
    switch: 'مفتاح',
    connecting:'جار استلام المعلومات',
    addDevice: 'اضافة الجهاز ',
    putDeviceOnConfigMode: 'اولا ، ضع الجهاز في وضع الإعداد (يجب أن يومض الضوء الموجود على الجهاز).',
    nextStep: 'المرحلة التالیة',
    connectZITCOCONFIGThroughtWifi: 'اتصل بشبكة ZITCO_config عبر Wi-Fi',
    password: '(الرمز:123456789)',
    chooseNetworkAndEnterItsPassword: 'حدد الشبكة المطلوبة وأدخل كلمة المرور الخاصة بها.',
    placeholderPassword: 'کلمة المرور',
    chooseNetwork:  "اختر شبکة..." ,
    search: 'بحث',
    saveModemInfo:'سجل المعلومات المودم.',
    addingDevice: 'جار اضافة الجهاز',
    addDevice: 'سجل',
    edit: 'تعدیل',
    deny: 'الغأ',
    save: 'حفظ',
    signIn: 'الدخول',
    enterYourPhoneNumber: 'أدخل رقم هاتفك المحمول',
    phoneNumber: 'رقم التلیفون:',
    sendCode: 'استلام الرسالة نسیه',
    serverInternalError: 'خطأ فی شبکة الداخلی',
    textMessage: 'رسالة نصیّة',
    activationWithTextMessage:'تفعیل عن طریق الرسائل نصیّه',
    activationCode: 'رمز التفعیل:',
    activationCodeSuccessfullySentTo: 'تم إرسال رمز التفعیل بنجاح إلی:',
    wrongCode: 'الکود الذي تم إدخاله غیر صحیح',
    back: 'العودة',
    offlineConfig: 'فعالسازی کاربری آفلاین',
    home: 'خانه',
    senarios: 'سناریو ها',
    addSenario: 'افزودن سناریو',
    senarioName: 'نام سناریو',
    pleaseUseAnUsedName: "لطفا نام غیر تکراری انتخاب کنید.",
    pleaseChooseASenarioName: 'لظفا یک نام برای سناریو انتخاب کنید.',
    thisSenarioNameAlreadyUsed: 'این نام برای سناریو دیگری انتخاب شده است، لطفا نام غیرتکراری وارد کنید.',
    delete: 'حذف',
    share: 'اشتراک گذاری',
    offlineUsage: 'کاربری آفلاین',
    toUseOfflineUsageYouShouldEnableWifi: 'برای استفاده از حالت آفلاین باید شبکه وای فای روشن باشد. (شما میتوانید تنظیمات مربوط به کاربری آفلاین را در صفحه تنظیمات تغییر دهید.)',
    requestForWifiPermission: 'درخواست دسترسی به فای وای',
    ZitkitNeedsThisPermissionToConnectToYourSmartSwitch: 'زیت کیت برای اتصال خودکار به کلید هوشمند نیاز به این دسترسی دارد.',
    notNow: 'فعلا نه',
    notAllowed: 'مجاز نیست',
    Allowed: 'مجاز است',
    searchForOfflineModule: 'جست و جو',
    toYouOfflineUsageYouShouldTurnOfflineUsageOnInSettings: 'برای استفاده از حالت کاربری آفلاین باید کاربری آفلاین را در تنظیمات فعال کنید.',
    termsAndPolices: 'قوانین',
    readTermsAndPolicies: 'مطالعه قوانین و شرایط استفاده',


    
}